export default __webpack_public_path__ + "static/media/info.f7e1428a.svg";